import main from './dev/main.json';

export enum i18nNamespace {
	MAIN = 'infa.profiling.fabric.main',
}

export const i18nNamspaceBundleMap: Record<i18nNamespace, object> = {
	[i18nNamespace.MAIN]: main,
};
